import React from 'react';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '../recoil/selectors';
import { WistiaPanel } from './WistiaPanel';

export const WorldsBestShapingPanel: React.FC = () => {
  const isMobile = useRecoilValue(isMobileState);
  const wistiaVideoId = isMobile ? 'txjj1yry1r' : 'uf6skqws6x';
  const padding = isMobile ? { padding: '145.0% 0 0 0' } : { padding: '56.25% 0 0 0' };

  return <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />;
};

export default WorldsBestShapingPanel;
